/*

? First, let's import the interface that will describe the shape of our chat object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the chat object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const broadcast: StateInterface["broadcast"] = {
	_id: "",
	broadcast_type: "",
	broadcast_mode: "",
	property_id: "",
	requirement_id: "",
	chat_id: "",
	commission_offered: 0,
	notes: "",
	status: "", // e.g., "delivered", "pending"
	delivered_at: new Date("2100-01-01T00:00:00.000Z"), // Placeholder date
	recipient_count: 0,
	created_by: {
		is_business_profile: false,
		user_id: "",
		business_profile_id: "",
	},
	created_at: "",
	updated_at: "",
	is_edited: false,
	is_expired: false,
	expired_at: "",
	trigger_expired_at: "",
	is_deleted: false,
	deleted_at: "",
	source: {
		url: "",
		component: "",
	},
	assigned_to: [], // Array of ObjectIds for users or business profiles assigned to the broadcast
	open_to_negotiation: false,
};
